import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const QuestionItemWrapper = styled(Link)`
    align-items: center;
    display: flex;
`;

export const QuestionItemText = styled.p`
    padding-left: 1.5rem;
    position: relative;
    text-underline-offset: 0.125rem;
    transition: 0.05s ease;

    &:before,
    &:after {
        border-radius: 50%;
        content: '';
        position: absolute;
        transition: 0.05s ease;
    }

    &:before {
        border: 2px solid transparent;
        height: 10px;
        left: -3px;
        top: 3px;
        width: 10px;
    }

    &:after {
        background-color: #5B5B5B;
        height: 6px;
        left: 1px;
        top: 7px;
        width: 6px;
    }

    &.active,
    &:hover {
        color: var(--main-color);
        text-decoration: underline;

        &:before { border-color: var(--main-color); }
        &:after { background-color: var(--main-color); }
    }
`;
